import type { SxProps, Theme } from '@mui/material/styles';
import { SIDE_PADDING } from './utils/consts';

export const rootSx: SxProps<Theme> = {
  gap: 1,
  alignItems: 'center',
  justifyContent: 'space-between',
  minWidth: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'background.paper',
};

export const messagesContainerSx = (hasMessages: string | boolean | null | undefined): SxProps<Theme> => ({
  flex: hasMessages ? 1 : undefined,
  width: '100%',
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  transition: 'max-height 0.25s ease-out, flex 0.25s ease-out',
  gap: 2,
  px: SIDE_PADDING,
  py: 0,
});
